export const EXTERNAL_NAVIGATION_EVENT = "nmdfc:external-navigation";

export const requestExternalNavigation = (url) => {
  if (typeof window === "undefined" || !url) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(EXTERNAL_NAVIGATION_EVENT, {
      detail: { url },
    }),
  );
};
